import React from 'react';

import { IntegrationDomain, IntegrationVersion } from 'api/usePublisherIntegrationTest';

import { IntegrationTestModal } from 'components/IntegrationTestModal/IntegrationTestModal';

import { docsUrls } from '../DeveloperSettings.constants';
import { IIntegrationSectionDependencies } from '../DeveloperSettings.integration';
import { EApiVersion, ESavingForm } from '../DeveloperSettings.types';
import { IVersionConfig } from '../DeveloperSettings.types';
import { useAuthPlayerForm } from '../hooks/useCallbackForms';
import { useIntegrationTestModal } from '../hooks/useIntegrationTestModal';

import { CallbackSection } from './CallbackSection';

type IAuthPlayerSectionProps = IIntegrationSectionDependencies;

export const AuthPlayerSection: React.FC<IAuthPlayerSectionProps> = ({
  publisherId,
  integrationData,
  updateIntegration,
  getIntegration,
  savingForm,
  setSavingForm,
  isProfilesEnabled,
  hasCategories,
  isWebStore,
  setTaskStatus
}) => {
  const form = useAuthPlayerForm({
    integrationData,
    updateIntegration,
    getIntegration,
    hasCategories,
    isWebStore,
    setTaskStatus,
    setSavingForm
  });

  const testModal = useIntegrationTestModal({
    publisherId,
    domain: IntegrationDomain.AUTHENTICATE_PLAYER,
    version: IntegrationVersion.V1,
    title: 'Authenticate Player Callback Test',
    callbackUrl: form.initialValues.playersAuthWebhook
  });

  const getAuthPlayerError = (): string | undefined => {
    if (form.touched.playersAuthWebhook) {
      return form.errors.playersAuthWebhook as string;
    }
    return undefined;
  };

  const versionConfigs: IVersionConfig[] = [
    {
      version: EApiVersion.V1,
      label: EApiVersion.V1,
      value: form.values.playersAuthWebhook,
      onChange: (value) => form.setFieldValue('playersAuthWebhook', value),
      error: getAuthPlayerError(),
      docsUrl: docsUrls.authenticatePlayer
    }
  ];

  const { schema, ...testModalProps } = testModal;

  return (
    <>
      <CallbackSection
        title="Authenticate Player Callback"
        versionConfigs={versionConfigs}
        onSave={form.submitForm}
        isSaveDisabled={!form.dirty || savingForm !== ESavingForm.NONE}
        isLoading={savingForm === ESavingForm.AUTH_PLAYER}
        disabled={isProfilesEnabled}
        onTestClick={testModal.openModal}
      />
      {schema && (
        <IntegrationTestModal
          {...testModalProps}
          schema={schema}
          schemaSelectorLabel="Player Authentication Method"
        />
      )}
    </>
  );
};
